// generated from 98_679 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasPushFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_push_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  // undefined: 39_776 (40.31%), defined 58_903 (59.69%)
  // true 54_856 (93.13%), false 4_047 (6.87%)
  raw_value: z.boolean().optional(),
  value: z.union([
    // boolean samples: 98_678 (100.00%)
    // true 92_739 (93.98%), false 5_939 (6.02%)
    z.boolean(),
    // string samples: 1 (0.00%)
    z.literal(""),
  ]),
  varies_by_app_group: z.literal(false),
});
